export default {
  title: 'Receive news and offers via email',
  form: {
    marketing_subscription: {
      label: 'Get exclusive offers, discounts, and updates delivered straight to your inbox',
    },
  },
};
